import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
const base_url = process.env.REACT_APP_API_URL;

const DepositHistory = () => {
 const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
 const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [recharge, setRecharge] = useState();
  const [filteredRecharge, setFilteredRecharge] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Open image in modal/popup
  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  // Close image modal/popup
  const closeImageModal = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  function formateT(params) {
    let result = params < 10 ? "0" + params : params;
    return result;
  }

  function timerJoin(params = "", addHours = 0) {
    let date = "";
    if (params) {
      date = new Date(Number(params));
    } else {
      date = new Date();
    }

    date.setHours(date.getHours() + addHours);

    let years = formateT(date.getFullYear());
    let months = formateT(date.getMonth() + 1);
    let days = formateT(date.getDate());

    let hours = date.getHours() % 12;
    hours = hours === 0 ? 12 : hours;
    let ampm = date.getHours() < 12 ? "AM" : "PM";

    let minutes = formateT(date.getMinutes());
    let seconds = formateT(date.getSeconds());

    return (
      years +
      "-" +
      months +
      "-" +
      days +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds +
      " " +
      ampm
    );
  }

  const handleChange = (e) => {
    const inputValue = e.target.value;
  
    const filteredData = recharge?.filter((value) => {
      if(value.id_order.includes(inputValue) || value.phone.includes(inputValue)){
        return value;
      }
      return false;
    });
    setFilteredRecharge(filteredData);
  };

  const withdrawData = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.post(
        base_url + "/api/webapi/admin/recharge",
        {
        },
        {
          headers: {
            Authorization:auth,
            "content-type": "application/json",
          },
        }
      );
      // console.log(response, "response");
      const data = response?.data.datas2;
      if (response?.data.status) {
        setRecharge(data);
        setFilteredRecharge(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    withdrawData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="wrapper">
        {/* Main Sidebar */}
        <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        <div className="content-wrapper d-flex flex-column"
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
          <section className="content mt-3">
            {/* Header with gradient */}
            <div className="d-flex flex-wrap justify-content-between align-items-center p-3 rounded shadow-sm"
              style={{ background: "linear-gradient(90deg, #4b6cb7, #182848)", color: "white" }}
            >
              <h3 className="mb-0 fw-bold">💳 Deposit History</h3>
              <button
                type="button"
                className="btn btn-light btn-sm fw-semibold shadow-sm"
                onClick={() => setRefresh(!refresh)}
              >
                <i className="fas fa-sync-alt me-1"></i> Refresh
              </button>
            </div>

            {/* Search box */}
            <div className="input-group mt-4 shadow-sm" style={{ maxWidth: "400px" }}>
              <span className="input-group-text bg-white border-end-0">
                <FontAwesomeIcon icon={faSearch} style={{ color: "#888" }} />
              </span>
              <input
                type="text"
                className="form-control border-start-0"
                placeholder="Search by Account or Txn ID..."
                onChange={handleChange}
                style={{ borderRadius: "0 30px 30px 0" }}
              />
            </div>

            {/* Table */}
            <div className="table-responsive mt-4 shadow-sm rounded w-100">
              <table className="table-hover align-middle text-center w-100">
                <thead style={{ backgroundColor: "#182848", color: "white" }}>
                  <tr className="text-nowrap">
                    <th className="px-3 text-nowrap">ID</th>
                    <th className="px-3 text-nowrap">Account</th>
                    <th className="px-3 text-nowrap">Type</th>
                    <th className="px-3 text-nowrap">Amount</th>
                    <th className="px-3 text-nowrap">Transaction Id</th>
                    <th className="px-3 text-nowrap">UTR</th>
                    <th className="px-3 text-nowrap">Proof</th>
                    <th className="px-3 text-nowrap">Status</th>
                    <th className="px-3 text-nowrap">Request Time</th>
                    <th className="px-3 text-nowrap">Accept Time</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRecharge?.map((draw) => (
                    <tr key={draw.id} className="align-middle border text-dark">
                      <td className="px-3 text-nowrap">{draw.id}</td>
                      <td className="px-3 text-nowrap"><b>{draw.phone}</b></td>
                      <td className="px-3 text-nowrap"><span className="badge bg-info">{draw.type}</span></td>
                      <td className="fw-semibold px-3">₹{draw.money}</td>
                      <td className="px-3 text-nowrap">{draw.id_order}</td>
                      <td className="px-3 text-nowrap">{draw.utr || "N/A"}</td>
                      <td className="px-3 text-nowrap">
                        {draw.url ? (
                          <div>
                            <img
                              src={`${base_url}${draw.url}`}
                              alt="Proof"
                              className="img-thumbnail"
                              style={{ width: "60px", height: "60px", objectFit: "cover", cursor: "pointer", borderRadius: "8px" }}
                              onClick={() => openImageModal(`${base_url}${draw.url}`)}
                            />
                            <div>
                              <small
                                className="text-primary"
                                style={{ cursor: "pointer" }}
                                onClick={() => openImageModal(`${base_url}${draw.url}`)}
                              >
                                View
                              </small>
                            </div>
                          </div>
                        ) : (
                          <span>-</span>
                        )}
                      </td>
                      <td className="px-3 text-nowrap">
                        <span
                          className={`badge px-3 py-2 ${draw.status === 1 ? "bg-success" : "bg-danger"}`}
                        >
                          {draw.status === 1 ? "Success" : "Rejected"}
                        </span>
                      </td>
                      <td className="px-3 text-nowrap">
                        {(draw.today.replace("T", " ")).slice(0,19)}
                      </td>

                      <td className="px-3 text-nowrap">
                        {(draw.time.replace("T", " ")).slice(0,19)}
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </div>

        {/* Modal with fade-in */}
        {showImageModal && (
          <div 
            className="modal fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(0,0,0,0.6)",
              backdropFilter: "blur(2px)"
            }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content shadow-lg border-0 rounded-3">
                <div className="modal-header bg-dark text-white">
                  <h5 className="modal-title">Payment Proof</h5>
                  <button type="button" className="btn-close btn-close-white" onClick={closeImageModal}></button>
                </div>
                <div className="modal-body text-center">
                  <img
                    src={selectedImage}
                    alt="Payment Proof"
                    className="img-fluid rounded"
                    style={{ maxHeight: "70vh" }}
                  />
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={closeImageModal}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

    </div>
  );
};

export default DepositHistory;